export default __webpack_public_path__ + "static/media/logo_letter_blue.cf7facf5.svg";